import { rfqQuoteDetailsSalesRepProductListStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList";
import { modalButtonsActionStyles } from "@pacific/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsSalesRepProductListStyles.quoteCalculationModal = {
    /* XNGAGE Changes */
    sizeVariant: "medium",
};

rfqQuoteDetailsSalesRepProductListStyles.quoteCalculationCancelButton = {
    /* XNGAGE Changes */
    ...modalButtonsActionStyles.cancelButton,
};
rfqQuoteDetailsSalesRepProductListStyles.quoteCalculationApplyAllGridItem = {
    width: 6,
    /* XNGAGE Changes */
    css: css`
        justify-content: flex-end;
    `,
};
rfqQuoteDetailsSalesRepProductListStyles.quoteCalculationApplyAllButton = {
    css: css`
        width: 100%;
    `,
    /* XNGAGE Changes */
    ...modalButtonsActionStyles.submitButton,
};
